import Alpine from "alpinejs";

Alpine.data("carousel", (id, autoScrollInterval = null) => {
  return {
    id: id,
    autoScrollInterval: autoScrollInterval,
    autoScrollTimer: null,
    get container() {
      return this.$el;
    },
    init() {
      this.setupEventListeners();

      if (this.autoScrollInterval && this.container.children.length > 0) {
        this.setupAutoScroll();
      }
    },

    setupAutoScroll() {
      this.startAutoScroll();

      this.container.addEventListener("scroll", () => {
        this.stopAutoScroll();
        this.startAutoScroll();
      });
    },
    setupEventListeners() {
      window.addEventListener(`scroll-carousel:${this.id}:next`, () => {
        this.scrollNext();
      });
      window.addEventListener(`scroll-carousel:${this.id}:previous`, () => {
        this.scrollPrevious();
      });
      window.addEventListener(`scroll-carousel:${this.id}:to`, (event) => {
        this.scrollTo(event.detail.index);
      });
    },
    scrollNext() {
      this.container.scrollBy({
        left: this.container.offsetWidth,
        behavior: "smooth",
      });
    },
    scrollPrevious() {
      this.container.scrollBy({
        left: -this.container.offsetWidth,
        behavior: "smooth",
      });
    },
    scrollTo(index) {
      const child = this.container.children[index];
      if (child) {
        this.container.scrollTo({
          left: child.offsetLeft,
          behavior: "smooth",
        });
      }
    },

    startAutoScroll() {
      this.autoScrollTimer = setInterval(() => {
        this.scrollNext();
      }, this.autoScrollInterval);
    },
    stopAutoScroll() {
      if (this.autoScrollTimer) {
        clearInterval(this.autoScrollTimer);

        this.autoScrollTimer = null;
      }
    },
  };
});
